module.exports = {
	errors: {
		disabledAccount: 'DISABLED_ACCOUNT',
		ssoAccount: 'SSO_ACCOUNT',
	},
};
